import { FloatingFormItem } from '@/components/_common';
import { useFunctionCreate } from '@/core/domain/enterprise/Functions/Functions.hooks';
import {
  EmployeeFunction,
  EmployeeFunctionCreate,
} from '@/core/domain/enterprise/Functions/Functions.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, Input, Modal, ModalProps, Row } from 'antd';

type Props = ModalProps & {
  onCancel: () => void;
  onCallback?: (employeeFunction: EmployeeFunction) => void;
};

export default function FunctionsCreateModal(props: Props) {
  const requiredField = useDefaultEmptyFieldError();
  const [form] = Form.useForm<EmployeeFunctionCreate>();

  const create = useFunctionCreate();

  const handleCancel = () => {
    form.resetFields();
    props.onCancel();
  };

  const handleCreate = async () => {
    const values = await form.validateFields();

    const result = await create.mutateAsync(values);

    if (!!props?.onCallback) props.onCallback(result);

    handleCancel();
  };

  return (
    <Modal
      {...props}
      title="Novo Cargo"
      okText="Criar"
      destroyOnClose
      onOk={handleCreate}
      onCancel={handleCancel}
    >
      <Form form={form}>
        <Row gutter={[12, 12]}>
          <Col span={24} md={12}>
            <FloatingFormItem name="name" label="Nome" rules={[requiredField]}>
              <Input maxLength={50} />
            </FloatingFormItem>
          </Col>

          <Col span={24} md={12}>
            <FloatingFormItem
              name="code"
              label="Código (CBO)"
              rules={[requiredField]}
            >
              <Input maxLength={10} />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
